import BillingsOrderForwardTaxiTaxiRecalculateRequest, {
  BillingsOrderForwardTaxiTaxiRecalculateRequestBody,
} from "./billings-order-forward-taxi-taxi-recalculate.request";

const create = (
  request: BillingsOrderForwardTaxiTaxiRecalculateRequest,
): BillingsOrderForwardTaxiTaxiRecalculateRequestBody => {
  return {
    billingContributions: request.billingContributions,
    billingNodes: request.billingNodes,
  };
};

const billingsOrderForwardTaxiTaxiRecalculateRequestFactory = {
  create,
};

export default billingsOrderForwardTaxiTaxiRecalculateRequestFactory;
